import { linkToPatient } from "$routes/patient/links";
import { Role } from "elephant-web/gql";
import { stringify } from "qs";

/**
 * This is an array of roles which have the ability to access
 * 'inpatient'
 */
export const INPATIENT_AUTHORISED_ROLES = [
  Role.Clinic,
  Role.Doctor,
  Role.Nurse,
  Role.Pharmacist,
  Role.Dispenser,
  Role.CashOfficer,
];

export const canUserAccessInpatient = (role: Role) => {
  return INPATIENT_AUTHORISED_ROLES.includes(role);
};

const appendSearch = (params: {
  patientUuid?: string;
  visitId?: string;
  detention?: boolean;
  selectedTab?: string;
}) => {
  if (!params.patientUuid) {
    return "";
  }

  return stringify(params, { addQueryPrefix: true });
};

export const PATIENT_INPATIENT_SEGMENT = "inpatient";
export const linkToPatientInpatient = (
  patientUuid?: string,
  visitId?: string,
) => {
  return `${linkToPatient()}/${PATIENT_INPATIENT_SEGMENT}${appendSearch({
    patientUuid,
    visitId,
  })}`;
};

export const PATIENT_INPATIENT_NOTES_SEGMENT = "notes";
export const PATIENT_INPATIENT_NOTES_DOCTOR_SEGMENT = "doctor";
export const PATIENT_INPATIENT_NOTES_NURSE_SEGMENT = "nurse";
export const linksToPatientInpatientNotes = (
  patientUuid?: string,
  visitId?: string,
) => {
  const base = `${linkToPatientInpatient()}/${PATIENT_INPATIENT_NOTES_SEGMENT}`;
  return {
    doctor: `${base}/${PATIENT_INPATIENT_NOTES_DOCTOR_SEGMENT}${appendSearch({
      patientUuid,
      visitId,
    })}`,
    nurse: `${base}/${PATIENT_INPATIENT_NOTES_NURSE_SEGMENT}${appendSearch({
      patientUuid,
      visitId,
    })}`,
  };
};

export const PATIENT_INPATIENT_DRUGCHART_SEGMENT = "drugchart";
export const linkToPatientInpatientDrugChart = (
  patientUuid?: string,
  visitId?: string,
) => {
  return `${linkToPatientInpatient()}/${PATIENT_INPATIENT_DRUGCHART_SEGMENT}${appendSearch(
    {
      patientUuid,
      visitId,
    },
  )}`;
};

export const PATIENT_INPATIENT_MEDICATION_SEGMENT = "medication";
export const linkToPatientInpatientMedication = (
  patientUuid?: string,
  visitId?: string,
) => {
  return `${linkToPatientInpatient()}/${PATIENT_INPATIENT_MEDICATION_SEGMENT}${appendSearch(
    {
      patientUuid,
      visitId,
    },
  )}`;
};

export const PATIENT_INPATIENT_MEDICATION_PRESCRIBE_SEGMENT = "prescribe";
export const linkToPatientInpatientMedicationPrescribe = (
  patientUuid?: string,
  visitId?: string,
) => {
  return `${linkToPatientInpatientMedication()}/${PATIENT_INPATIENT_MEDICATION_PRESCRIBE_SEGMENT}${appendSearch(
    {
      patientUuid,
      visitId,
    },
  )}`;
};

export const PATIENT_INPATIENT_VITALS_SEGMENT = "vitals";
export const linkToPatientInpatientVitals = (
  patientUuid?: string,
  visitId?: string,
) => {
  return `${linkToPatientInpatient()}/${PATIENT_INPATIENT_VITALS_SEGMENT}${appendSearch(
    {
      patientUuid,
      visitId,
    },
  )}`;
};

export const PATIENT_INPATIENT_INVESTIGATIONS_SEGMENT = "investigations";
export const linkToPatientInpatientInvestigations = (
  patientUuid?: string,
  visitId?: string,
) => {
  return `${linkToPatientInpatient()}/${PATIENT_INPATIENT_INVESTIGATIONS_SEGMENT}${appendSearch(
    {
      patientUuid,
      visitId,
    },
  )}`;
};

export const PATIENT_INPATIENT_ADMIT_SEGMENT = "admit";
export const linkToPatientInpatientAdmit = (
  searchParams: { patientUuid?: string; detention?: boolean } = {},
) => {
  // Query params/search as to follow convention of other patient paths
  return `${linkToPatientInpatient()}/${PATIENT_INPATIENT_ADMIT_SEGMENT}${appendSearch(
    searchParams,
  )}`;
};
